import axios from '@/utils/api'
import rotas from '@/constants/rotas'

const actions = {
  download ({ commit }, { fileKey, id }) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: rotas.ARRECADACAO.DOWNLOAD_DOCUMENTOS(fileKey, id)
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/documentoArrecadacao.js